import { GatewayReadingDevice, DeviceConfig } from "./Gateways";

export type LdsuStateType = {
    UID: string;
    SNO: string;
    PRV: string;
    FWV: string;
    MFG: string;
    name: string;
    NAME: string;
    DID: string;
    TERM: string;
};

export type LdsApp = Record<string, any> & {
    NAME: string;
    APPID: string;
    DESCRIPTION: string;
    UNITS?: string[];
};

export type LdsuDto = {
    uuid: string;
    create_time: Date;
    modify_time: Date;
    gateway_uuid: string;
    UID: string;
    IID: string;
    PORT: string;
    DID: string;
    PRV: string;
    FWV: string;
    MFG: string;
    SNO: string;
    NAME: string;
    NICK: string | null;
    TERM: string;
    OBJ: string;
    APP: LdsApp[] | null;
    association: any;
};

type CommonLdsuProperties = {
    [K in keyof LdsuDto &
        keyof DeviceConfig &
        keyof GatewayReadingDevice]: K extends LdsuDto[K] ? LdsuDto[K] : never;
};

export type CombinedLdsu = CommonLdsuProperties &
    (Partial<LdsuDto> & Partial<DeviceConfig> & Partial<GatewayReadingDevice>);

export const LDSU_STATUS = {
    REACHABLE: "Reachable",
    NOT_REACHABLE: "Not Reachable",
    NOT_READY: "Not Ready",
};
